import { render, staticRenderFns } from "./NObjectCardComment.vue?vue&type=template&id=cd62ebe2&scoped=true&"
import script from "./NObjectCardComment.vue?vue&type=script&lang=js&"
export * from "./NObjectCardComment.vue?vue&type=script&lang=js&"
import style0 from "./NObjectCardComment.vue?vue&type=style&index=0&id=cd62ebe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd62ebe2",
  null
  
)

export default component.exports